import { LazyLoader } from "@NextSkyTheme/lazy-load";

document.addEventListener("DOMContentLoaded", function () {
  function addProductEntry(productJson, storedProducts) {
    if (storedProducts === null) storedProducts = [];
    const currentProductID = productJson.toString();
    if (!storedProducts.includes(currentProductID)) {
      storedProducts.unshift(currentProductID);
      if (storedProducts.length > 25) {
        storedProducts.pop();
      }
      localStorage.setItem(
        "recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    } else {
      const index = storedProducts.indexOf(currentProductID);
      if (index > -1) {
        storedProducts.splice(index, 1);
      }
      storedProducts.unshift(currentProductID);
      localStorage.setItem(
        "recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    }
  }

  const prodData = document.querySelector("[data-product-json]");
  if (prodData != null) {
    const productJson = JSON.parse(prodData.innerHTML);
    const storedProducts = JSON.parse(
      localStorage.getItem("recently-viewed-products")
    );
    addProductEntry(productJson, storedProducts);
  }
});

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          new LazyLoader(".image-lazy-load");
        })
        .finally(() => {})
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);

// Old School: sticky add to cart with the size choice (CRO point 3), replaces Purity's scroll handler.
// Shows once the main Add to cart has scrolled up out of view (behind the sticky header counts as out
// of view) and hides while that button or the footer is in view, on mobile and desktop. While shown it
// sets html.show-sticky-cart-active (the scratch card pill and back-to-top key off it) and
// --os-sticky-buy-h on <html>. The size select is Purity's variant-swatch-select (module-variant-swatch.js
// re-renders the section on change); this class only keeps the pill's visible value in step.
class StickyAddCart extends HTMLElement {
  connectedCallback() {
    if (this._osReady) return;
    this.main =
      this.closest(".main-product-section") ||
      document.querySelector(".main-product-section");
    this.primary = this.main && this.main.querySelector(".block-product__buttons");
    if (!this.primary) return;
    this._osReady = true;
    this.footer = document.querySelector("footer");
    this.header = document.querySelector(".site-header");
    this.shown = false;
    this._frame = 0;
    this.onScroll = () => {
      if (this._frame) return;
      this._frame = requestAnimationFrame(() => {
        this._frame = 0;
        this.update();
      });
    };
    window.addEventListener("scroll", this.onScroll, { passive: true });
    window.addEventListener("resize", this.onScroll, { passive: true });

    this.select = this.querySelector(".os-sab__select");
    this.valueEl = this.querySelector(".os-sab__value");
    this.buy = this.querySelector(".sticky-sticky__buy-buttons");
    this.pill = this.querySelector(".os-sab__size");
    this.hint = this.querySelector("[data-os-sab-hint]");
    if (this.select) {
      this.onSelect = () => {
        this.paint();
        this.clearNudge();
        // Old School: point this bar's form at the new variant straight away, so a quick tap on
        // Add to cart cannot add the old size while the section re-render is still loading
        const id = this.buy && this.buy.querySelector('input[name="id"]');
        if (id) id.value = this.select.value;
      };
      this.select.addEventListener("change", this.onSelect);
      // Old School: no size chosen yet (the page loads that way, snippets/os-size-pending.liquid).
      // ProductForm (module-add-to-cart.js) fires os:size-required when this bar's Add to Cart is
      // tapped with an empty id; open this pill instead of scrolling the shopper back up the page.
      this.onSizeRequired = (event) => {
        if (this.select.value) return;
        event.preventDefault();
        this.askForSize();
      };
      this.addEventListener("os:size-required", this.onSizeRequired);
    }
    if (this.buy) {
      // Old School: module-variant-swatch.js swaps this block's HTML after every variant change
      // (from the main picker or from here); read the variant back from the new form
      this.observer = new MutationObserver(() => this.fromForm());
      this.observer.observe(this.buy, { childList: true });
    }
    this.update();
  }

  disconnectedCallback() {
    if (!this._osReady) return;
    this._osReady = false;
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onScroll);
    if (this._frame) cancelAnimationFrame(this._frame);
    this._frame = 0;
    if (this.select && this.onSelect)
      this.select.removeEventListener("change", this.onSelect);
    if (this.onSizeRequired)
      this.removeEventListener("os:size-required", this.onSizeRequired);
    this.clearNudge();
    if (this.observer) this.observer.disconnect();
    if (this.shown) this.toggle(false);
  }

  // Old School: Add to Cart was tapped before a size was chosen. Focus the pill's select and call
  // showPicker() where the browser has it, so the native size list opens where allowed; either way ring
  // the pill and show "Please choose a size" above it for a moment (a status region for screen readers).
  askForSize() {
    if (!this.select) return;
    if (this.pill) {
      this.pill.classList.remove("os-sab__size--nudge");
      void this.pill.offsetWidth;
      this.pill.classList.add("os-sab__size--nudge");
    }
    if (this.hint) {
      const text = this.hint.getAttribute("data-os-sab-hint");
      this.hint.hidden = false;
      this.hint.textContent = "";
      requestAnimationFrame(() => {
        if (this.hint) this.hint.textContent = text;
      });
    }
    clearTimeout(this._nudgeTimer);
    this._nudgeTimer = setTimeout(() => this.clearNudge(), 2800);
    try {
      this.select.focus({ preventScroll: true });
    } catch (e) {}
    if (typeof this.select.showPicker === "function") {
      try {
        this.select.showPicker();
      } catch (e) {}
    }
  }

  clearNudge() {
    clearTimeout(this._nudgeTimer);
    this._nudgeTimer = 0;
    if (this.pill) this.pill.classList.remove("os-sab__size--nudge");
    if (this.hint) {
      this.hint.hidden = true;
      this.hint.textContent = "";
    }
  }

  update() {
    const vh = window.innerHeight;
    let top = 0;
    if (this.header) {
      top = Math.min(Math.max(this.header.getBoundingClientRect().bottom, 0), vh);
    }
    const passed = this.primary.getBoundingClientRect().bottom <= top;
    const footerIn = this.footer
      ? this.footer.getBoundingClientRect().top < vh
      : false;
    this.toggle(passed && !footerIn);
  }

  toggle(show) {
    if (show === this.shown) return;
    this.shown = show;
    this.classList.toggle("show-sticky-cart", show);
    const root = document.documentElement;
    root.classList.toggle("show-sticky-cart-active", show);
    if (show) {
      this.removeAttribute("inert");
      root.style.setProperty("--os-sticky-buy-h", `${this.offsetHeight}px`);
    } else {
      this.setAttribute("inert", "");
      root.style.setProperty("--os-sticky-buy-h", "0px");
    }
  }

  fromForm() {
    if (!this.select) return;
    const id = this.buy && this.buy.querySelector('input[name="id"]');
    if (id && id.value && this.select.value !== id.value) {
      const match = Array.from(this.select.options).some(
        (option) => option.value === id.value,
      );
      if (match) this.select.value = id.value;
    }
    this.paint();
  }

  paint() {
    if (!this.select || !this.valueEl) return;
    const option = this.select.options[this.select.selectedIndex];
    if (option) this.valueEl.textContent = option.dataset.value || option.text;
    // Old School: the placeholder look (no Size label, Select a size) only while no size is chosen
    if (this.pill) this.pill.classList.toggle("os-sab__size--empty", !this.select.value);
  }
}
customElements.define("sticky-add-cart", StickyAddCart);

const infoGallerySlide = () => {
  const gallery = document.querySelectorAll(".info-gallery__card");
  gallery.forEach((e) => {
    e.addEventListener("mouseover", (event) => {
      const currentTarget = event.currentTarget;
      if (!currentTarget.classList.contains("active")) {
        gallery.forEach((el) => {
          el.classList.remove("active");
        });
        currentTarget.classList.add("active");
      }
    });
  });
};
document.addEventListener("shopify:section:load", function () {
  infoGallerySlide();
});
infoGallerySlide();
